<template>
  <div
    class="portfolio portfolio1 portfolio--1 lp-section width-expand padding-2xl-vertical l:padding-max-vertical"
    :class="`bg-${backgroundColor}`"
    :id="`Portfolio1-${pageUid}`">
    <div
      class="section-container custom-portfolio-section container-l margin-auto">
      <h2
        class="section-title l:hidden"
        v-if="isNonEmptyString(title)"
        v-html="nl2Br(title)"
        :class="`c-${titleColor}`"></h2>
      <div
        class="content-wrap flex flex-between flex-stretch flex-break-column-center">

        <div class="media-wrap width-expand flex-center flex-middle">
          <img v-if="image.show" v-bind="image" class="animation-image" />
        </div>
        <div class="text-wrap width-expand">
          <h2
            v-if="isNonEmptyString(title)"
            v-html="nl2Br(title)"
            :class="`c-${titleColor}`"
            class="section-title text-inline-start l:visible margin-l-bottom"></h2>

          <div class="section-intro text-2xl">
            <p>
              <strong
                v-if="isNonEmptyString(subTitle)"
                v-html="nl2Br(subTitle)"
                :class="`c-${subTitleColor}`"></strong>
            </p>
            <p
              v-if="isNonEmptyString(text)"
              v-html="nl2Br(text)"
              :class="`c-${subTitleColor}`"></p>
          </div>

          <div
            class="features flex flex-start gap-2xl flex-wrap margin-2xl-bottom flex-break-column-center features--4-features">
            <div class="feature" v-for="feature of features">
              <div
                class="feature__title margin-s-bottom flex gap-m flex-break-center">
                <div class="feature__title-icon">
                  <img
                    :src="feature.image"
                    :alt="tu('lp.sections.portfolio1.featureIconAlt')" />
                </div>
                <div class="feature__title-text">
                  {{ feature.title }}
                </div>
              </div>
              <div class="feature__text text-s">
                <p v-html="nl2Br(feature.text)"></p>
              </div>
            </div>
          </div>

          <div
            class="custom-portfolio-section__content-button-wrap flex flex-center l:flex-end flex-middle">
            <form-button
              class="custom-portfolio-section__content-button"
              v-if="button.show"
              v-bind="button"
              @click="
                track('portfolio1|button|click', { value: button.text }).then(
                  button.navigationHandler
                )
              "></form-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      subTitle: "",
      text: "",
      image: {},
      features: [
        {
          image: "",
          title: "",
          text: "",
        },
      ],
      button: {},
      backgroundColor: "",
      titleColor: "",
      subTitleColor: "",
      featureTitleColor: "",
      featureTextColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.portfolio1 {
  .section-title {
    line-height: 1.05;
  }

  .media-wrap {
    @media (max-width: 1024px) {
      margin-bottom: var(--margin-s);
    }
  }

  .animation-image {
    max-width: 400px;
    max-height: 400px;
    width: 400px;
    height: 400px;

    @media (max-width: 1024px) {
      max-width: 300px;
      max-height: 300px;
      width: 300px;
      height: 300px;
    }

    @media (max-width: 767px) {
      max-width: 260px;
      max-height: 260px;
      width: 260px;
      height: 260px;
    }
  }

  .text-wrap {
  }

  .section-container {
  }

  .section-title {
    max-width: 450px;

    @media (max-width: 1024px) {
      text-align: center;
      margin-bottom: var(--margin-l);
      margin-inline-start: auto;
      margin-inline-end: auto;
    }
  }

  .content-wrap {
    @media (max-width: 1024px) {
      text-align: center;
      margin-inline-start: auto;
      margin-inline-end: auto;
    }
  }

  .section-intro {
    max-width: 580px;
    line-height: 1.1;
    font-size: var(--font-xl);
    margin-bottom: var(--margin-l);

    @media (max-width: 1024px) {
      font-size: var(--font-xl);
      margin-bottom: var(--margin-xl);
      margin-inline-start: auto;
      margin-inline-end: auto;
    }

    p {
      margin: 0;
      font-size: var(--font-xl);
      @media (max-width: 1024px) {
        font-size: var(--font-xl);
      }
    }

    p + p {
      margin-top: var(--margin-s);
    }
  }

  .feature {
    flex: 0 0 calc(33% - 2 / 3 * var(--margin-2xl));

    @media (max-width: 1024px) {
      flex: 100%;
      text-align: center;
      max-width: 450px;
    }

    @media (max-width: 767px) {
      flex: 100%;
      text-align: center;
      max-width: 320px;
    }
  }

  .features.features--2-features,
  .features.features--4-features,
  .features.features--7-features {
    .feature {
      flex: 0 0 calc(50% - 1 / 2 * var(--margin-2xl));

      @media (max-width: 1024px) {
        flex: 100%;
        text-align: center;
        max-width: 450px;
      }

      @media (max-width: 767px) {
        flex: 100%;
        text-align: center;
        max-width: 320px;
      }
    }
  }

  .feature__title {
    display: flex;
    align-items: center;
  }

  .feature__title-text {
    font-weight: 600;
    font-size: var(--font-xl);
    line-height: 1.1;
  }

  .feature__title-icon img {
    max-height: 32px;
    min-height: 25px;
    min-width: 25px;
    line-height: 1.1;
    width: auto;
  }

  &__content-button {
    @media (max-width: 1024px) {
      margin-inline-start: auto;
      margin-inline-end: auto;
    }
  }

  .feature__text {
    font-size: var(--font-s);

    p {
      font-size: var(--font-s); // required becuase of bad ekla reset
      line-height: 1.2; // required becuase of bad ekla reset
      margin: 0;
    }

    p + p {
      margin-top: var(--margin-s);
    }
  }
}
</style>
